import styled from 'styled-components';

import CarrierVehicleEditModal from './component';

export default styled(CarrierVehicleEditModal)`
  .carrier-vehicle-edit-modal {
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    &__section {
      margin-bottom: 0;
      &--dark {
        background-color: var(--grey200);
      }
    }

    &__title {
      color: var(--grey900);
      font-weight: bold;
    }

    &__column {
      display: flex;
      flex-direction: column;
      width: 50%;

      &--right {
        padding-left: 4rem;
      }

      &--left {
        padding-right: 4rem;
      }
    }

    &__row-inputs {
      display: flex;
      flex-wrap: wrap;

      > div {
        margin-bottom: 1rem;
        margin-right: 1.5rem;
        width: 20%;
      }
    }

    &__row {
      display: flex;
      flex-wrap: wrap;
      width: 100%;

      h2 {
        width: 100%;
      }

      &--mb {
        margin-bottom: 1rem;
      }
    }

    &__input {
      display: flex;
      flex-grow: 1;
      margin-right: 1rem;
      width: auto;

      input {
        height: auto;
      }

      &--inline {
        margin-right: 0;
      }

      &--inline-half {
        flex-basis: 50%;
        margin-right: 0;
      }
    }

    &__select {
      height: 32px;
    }

    &__select-label,
    &__date-label {
      font-weight: normal;
      font-size: 1em;
      color: var(--grey900);
      display: block;
      margin-bottom: 10px;
    }

    &__doc-link {
      padding: 0;
      width: 50%;

      .btnWrapper {
        align-items: flex-start;
        justify-content: flex-start;
      }
    }

    &__list-checkbox {
      margin-bottom: 1rem;
    }

    &__footer-actions {
      display: flex;
      justify-content: space-between;
    }

    &__delete-btn {
      button {
        color: var(--error700);
        padding: 0;
      }
    }

    &__general-errors {
      background: var(--grey200);
      border: 1px solid var(--grey200);
      color: var(--error700);
      display: flex;
      margin: -2rem -3rem 2rem;
      padding: 0.5rem 3rem;
    }

    &__documents-list {
      width: 100%;
      .documents-list {
        margin-bottom: 2rem;
        &__title {
          display: none;
        }
      }
    }
  }
`;
